import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AsesmenAwalGadar/AsesmenSurveyPrimerGadar";
import { SurveyPrimerGawatDarurat } from "@/types/asesmen_gawat_darurat";

interface Data {
  id: number;
  pasien_rm: number;
  register_id: number;
  content: any;
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "asesmen-survey-primer-gadar"
})
class AsesmenSurveyPrimerGadarStore extends VuexModule {
  loading = false;
  asesmen: SurveyPrimerGawatDarurat = null;

  registerId: string = null;

  @Mutation
  SET_RECORD(val) {
    this.asesmen = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  SET_REGISTER_ID(val) {
    this.registerId = val == null ? null : String(val);
  }

  @Mutation
  CLEAR_STORE() {
    this.asesmen = null;
    this.registerId = null;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    if (this.registerId !== String(registerId)) {
      this.SET_RECORD(null);
    }

    this.SET_REGISTER_ID(registerId);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    if (this.registerId !== String(registerId)) return;

    this.SET_RECORD(response);
  }

  @Action({ rawError: true })
  clear(): void {
    this.CLEAR_STORE();
  }
}

export default getModule(AsesmenSurveyPrimerGadarStore);
